import React from 'react';
import SpotSuper from './spotSuper';

export default function Spot() {
  return (
    <>
      <SpotSuper />
    </>
  )
}
